/* Add properties to a lookup table */
export function addToSet(set, array) {
  let l = array.length;
  while (l--) {
    if (typeof array[l] === 'string') {
      array[l] = array[l].toLowerCase();
    }
    set[array[l]] = true;
  }
  return set;
}

/* Shallow clone an object */
export function clone(object) {
  const newObject = {};
  let property;
  for (property in object) {
    if (Object.prototype.hasOwnProperty.call(object, property)) {
      newObject[property] = object[property];
    }
  }
  return newObject;
}



// WEBPACK FOOTER //
// ../src/utils.js